import { render } from "./PurchaseItemAssociateModal.vue?vue&type=template&id=79a19eb2&scoped=true&ts=true&lang=pug"
import script from "./PurchaseItemAssociateModal.vue?vue&type=script&lang=ts"
export * from "./PurchaseItemAssociateModal.vue?vue&type=script&lang=ts"

import "./PurchaseItemAssociateModal.vue?vue&type=style&index=0&id=79a19eb2&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a19eb2"]])

export default __exports__